<script>
import OrangeHotSpot from '@/src/components/svg/OrangeHotSpot.vue'

export default {
  components: { OrangeHotSpot },
}
</script>

<template>
  <div id="indicator" :class="['indicator']" v-on="$listeners">
    <OrangeHotSpot />
  </div>
</template>

<style lang="scss">
@import '@design';

.indicator {
  // SVG Styles
  svg {
    .a {
      fill: none;
      stroke: #fff;
      stroke-miterlimit: 10;
    }
    .b {
      fill: #fff;
    }
    .c {
      fill: #ff671d;
    }
  }

  &.large {
    svg {
      width: 290px;
      height: 290px;
    }
  }

  &.inactive {
    svg .b {
      fill: #fff;
    }
  }
}
</style>
